/**
 * [Modules] Reusable methods shared across the site. Typically, methods defined here _should_ be used across several pages.
 * As opposed to Utils, these methods are ran on document ready if its query is available.
 */

import selectric from 'selectric';
import select2 from 'select2';

import _ from 'lodash';
import onscreen from 'onscreen';
import * as Utils from './born.utils';

// Modules
import Carousel from '../modules/module.carousel';
import Views from '../modules/module.views';
import Video from '../modules/module.video';
import OverlayToggle from '../modules/module.overlaytoggle';
import Modal from '../modules/module.modal';
import TelInput from '../modules/module.intl-tel-input';
import TrackingLayer from '../modules/module.tracking-layer';
import Toggle from '../modules/module.toggle';
import ProductRating from "../modules/module.rating";

var Modules = {
	carousel: {
		default: '[data-slick]',
		init: function(query) { let carousel = new Carousel(query || this.default); return carousel; }
	},

	gridViewType: {
		default: '[data-view-props]',
		init: function(query) { let views = new Views(query || this.default); }
	},

	video: {
		default: '[data-video]',
		init: function(query) { let videos = new Video(query || this.default); }
	},

	trackingLayer: {
		default: '[data-tracking], video',
		init: function(query) { let trackedElements = new TrackingLayer(query || this.default); }
	},

	/**
	 * Series of methods to handle hidden content on the page
	 * Basic usage is:
	 * <span class="content-trigger" data-toggle-target=".target-content">Click me!</span>, where:
	 * data-parent : (optional) selector to the trigger's parent. Defaults to parentNode.
	 * data-toggle-target : selector to the trigger's content.
	 */
	toggle: {
		default: '[data-toggle-target]',
		init: function(query) { let toggles = new Toggle(query || this.default); }
	},

	overlayToggle: {
		default: '[data-toggle-overlay]',
		init: function(query) { let toggles = new OverlayToggle(query || this.default); }
	},

	/**
	 * [Simple modal toggle using born.modals]
	 */
	modalToggle: {
		default: '[data-modal]',
		init: function(query) {
			let selector = query || this.default,
				toggles = document.querySelectorAll(selector + ':not([data-initialized])');

			[].forEach.call(toggles, this.setToggles.bind(this));
		},

		setToggles: function(toggle) {
			let randId = Math.floor(new Date().getTime() * Math.random());

			toggle.modalToggle = {};
			toggle.modalToggle.options = this.getSettings(toggle);

			toggle.modalToggle.options.modalID = toggle.modalToggle.options.modalID || randId;

			if(toggle.modalToggle.options.auto) {
				this.openModal.call(toggle);
			}

			else {
				toggle.addEventListener('click', this.openModal);
			}

			toggle.setAttribute('data-initialized', true);
		},

		getSettings: function(toggle) {
			let options = toggle.getAttribute('data-modal');

			return options ? JSON.parse(options) : {};
		},

		openModal: function() {
			let ToggledModal = new Modal({
				modalID:		this.modalToggle.options.modalID,
				overlayClass: 	this.modalToggle.options.overlayClass || 'generic-overlay',
				modalClass: 	this.modalToggle.options.modalClass || 'modal--fluid',
				modalContent: 	document.querySelector(this.modalToggle.options.content) || ''
			});
		}
	},

	/**
	 * Handles up/down quantity value.
	 * Useful to make up for certain browsers that
	 * don't have a built-in spinner for this.
	 * Also fires custom events for easy action hooks (like add/update/delete from cart, for example).
	 */
	qtyControl: {
		default: '[data-qty-control]',
		init: function(query) {
			var self = this,
				selector = query || this.default,
				controls = document.querySelectorAll(selector + ':not([data-initialized])');

			[].forEach.call(controls, function(control){
				self.setupControls.call(self, control);
			});
		},

		setupControls: function(control) {

			var scope = this,
				$qtyControl = $(control),
				$inputBox = $qtyControl.find('.value'),
				$ctrlBtns = $qtyControl.find('.plus, .minus'),
				downInterval,
				downTimeout,
				clickEvtDown =  window.outerWidth < Utils.breakpoints.mobile ? 'touchstart' : 'mousedown',
				clickEvtUp = window.outerWidth < Utils.breakpoints.mobile ? 'touchend' : 'mouseup',
				debouncedChange = _.debounce(this.triggerChange, 400);
			// prevValue = parseInt($inputBox.val());

			$qtyControl.attr('data-initialized', true);

			$inputBox.on('keydown', function(evt) {
				var keys = Utils.allowedNumInput(evt);

				if (keys.upDown) {
					evt.preventDefault();
					scope.updateQty($(this), evt, debouncedChange);
				}

				if (!keys.allowed) {
					evt.preventDefault();
					return false;
				}

			});

			// $inputBox.on('input', function(evt){
			//     var $currInput = $(this);

			//     if(parseInt($currInput.val()) > parseInt($currInput.attr('max'))){
			//         $currInput.val(prevValue);
			//     }

			//     prevValue = parseInt($currInput.val());
			// });

			$ctrlBtns.on(clickEvtDown, function(evt) {
				scope.updateQty($inputBox, evt, debouncedChange);

				//Increase qty continously until user releases click/tap
				downTimeout = setTimeout(function() {
					downInterval = setInterval(function() {
						scope.updateQty($inputBox, evt, debouncedChange);
					}, 100);
				}, 275);
			});

			$ctrlBtns.on(clickEvtUp + ' mouseleave', function() {
				clearTimeout(downTimeout);
				clearInterval(downInterval);
			});

			$inputBox.on('input', debouncedChange);

		},

		triggerChange: function() {
			$(this).trigger('change');
		},

		updateQty: function($input, evt, updateCallback) {
			if ($input.prop('readonly')) {
				return false;
			}

			var parsedVal = parseInt($input.val()),
				currVal = (parsedVal === 0 || parsedVal) ? parsedVal : 0,
				newVal = currVal,
				minVal = parseInt($input.attr('min')) || 0;

			if ($(evt.target).hasClass('plus') || evt.keyCode == 38) {
				newVal = currVal + 1;
			}

			else if ( currVal > minVal ) {
				newVal = currVal - 1;
			}

			if (newVal !== currVal) {
				$input.val(newVal);
				$input.trigger('input');
				updateCallback.call($input);
			}
			var quickViewDetObj = $('.pdp__actions--extra__button a');
			if(quickViewDetObj.length == 1) {
				this.appendQuantity(quickViewDetObj, newVal);
			}
		},
		appendQuantity: function(obj, qtyValue) {
			var qtyKey = 'Quantity';
			var uri = obj.attr('href');
			var qtyReg = new RegExp("([?|&])" + qtyKey + "=.*?(&|$)", "i");
			var separator = uri.indexOf('?') !== -1 ? "&" : "?";
			if (uri.match(qtyReg)) {
				uri = uri.replace(qtyReg, '$1' + qtyKey + "=" + qtyValue + '$2');
			} else {
				uri =  uri + separator + qtyKey + "=" + qtyValue;
			}
			obj.attr('href', uri);
		}
    },
    
    /**
     * Handles quantity selector events
     */
    qtySelect: {
        default: '[data-qty-select]',
        init(query) {
			let self = this,
				selector = query || this.default,
				controls = $(selector + ':not([data-initialized])');

			[].forEach.call(controls, function(control){
				self.setupControls.call(self, control);
			});
        },
        setupControls(control) {
            var self = this,
				$qtyControl = $(control);

            $qtyControl.attr('data-initialized', true);
            
            $qtyControl.on('change', function () {
                
            });
        }
    },

	/**
	 * Prevents outer scrolling when scrolling on a overflowed container
	 */
	cancelScroll: {
		default: '[data-cancel-scroll]',
		init: function(query) {
			//We don't need this on mobile
			if (window.innerWidth <= Utils.breakpoints.mobile) {
				return;
			}

			var scope = this,
				selector = query || this.default,
				$scrollables = $(selector + ':not([data-initialized])');

			$scrollables.attr('data-initialized', true);

			$scrollables.on('DOMMouseScroll mousewheel', function(evt) {
				scope.scrollEvent.call(scope, evt, this);
			});
		},

		scrollEvent: function(evt, scrolledElement) {
			var $scrolledElement = $(scrolledElement),
				scrollTop = scrolledElement.scrollTop,
				scrollHeight = scrolledElement.scrollHeight,
				height = $scrolledElement.innerHeight(),
				delta = evt.originalEvent.wheelDelta,
				goingUp = delta > 0;

			if (!goingUp && -delta > scrollHeight - height - scrollTop) {
				$scrolledElement.scrollTop(scrollHeight);

				return this.preventOuterScroll(evt);
			} else if (goingUp && delta > scrollTop) {
				$scrolledElement.scrollTop(0);

				return this.preventOuterScroll(evt);
			}

		},

		preventOuterScroll: function(evt) {
			evt.stopPropagation();
			evt.preventDefault();
			evt.returnValue = false;

			return false;
		}
	},

	jumpTo: {
		default: '[data-jumpto]',
		init: function(query) {
			$(query || this.default).on('click', function(e) {
				e.preventDefault();
				Utils.jumpTo.call(this, this.getAttribute('data-jumpto'));
			});
		}
	},

	/**
	 * Simple method to allow anchor elements to navigate back/forward in history.
	 * data-history: [default: "back"] -> "back" or "forward"
	 */
	history: {
		default: '[data-history]',
		init: function(query) {
			let navItems = document.querySelectorAll(query + ':not([data-initialized])');

			[].forEach.call(navItems, this.setHandler.bind(this));
		},

		setHandler: function(item) {
			item.addEventListener('click', this.navigate);
		},

		navigate: function(e) {
			let direction = this.getAttribute('data-history');

			e.preventDefault();

			if(direction === 'forward') {
				window.history.forward();
			}

			else {
				window.history.back();
			}
		}
	},

	/**
	 * Very basic lazy loading logic
	 * called data-born-lazy to avoid conflicts
	 */
	bornLazy: {
		default: '[data-born-lazy]',
		init: function(query) {
			let selector = query || this.default,
				OS = new onscreen({tolerance: -900,debounce: 0});

			OS.on('enter', selector, this.lazyRender);
		},
		lazyRender: function(el) {
			if(el.classList.contains('born-lazy-loaded')){
				return;
			}

			var imgSrc = el.getAttribute('data-born-lazy');

			if (el.nodeName === 'IMG') {
				el.src = imgSrc;
			}

			else {
				el.style.backgroundImage = 'url("' + imgSrc + '")';
			}

			$(el).imagesLoaded({background: true}, function() {
				el.removeAttribute('data-born-lazy');
				el.classList.add('born-lazy-loaded');
			});
		}
	},

	selectTags: {
		default: 'select',
		init: function (query) {
			var scope = this,
				selector = query || this.default,
				selectEls = document.querySelectorAll(selector + ':not([data-initialized])');

			if(selectEls.length){
				//Loops cause we need to check individual items for special class
				[].forEach.call(selectEls, function(selectEl){
					var $selectEl = $(selectEl);
					if($selectEl.hasClass('select2-option')) {
						$selectEl.select2({
						    sorter: function(data) {
						    	var defOption = false;
						    	if(data.length > 0) {
						    		defOption = (data.splice(data.findIndex(e => e.id === ""),1));
						    		if(defOption && defOption.length > 0) {
						    			defOption = defOption[0];
						    		} else {
						    			defOption = false;
						    		}
						    	}
						        var optionData = data.sort(function(a, b) {
						            return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
						        });
						        if(defOption) {
						        	optionData.unshift(defOption);
								}
						    	return optionData;
						    }
						});
						$selectEl.on('select2:open', () => {
							let $searchField = $('.select2-container.select2-container--open').find('.select2-search__field');
							$searchField.attr('placeholder', `${Resources.SELECT2_SEARCH}...`);
						});
					} else {
						selectEl.selOptions = selectEl.hasAttribute('data-select-options') ? JSON.parse(selectEl.getAttribute('data-select-options')) : false;

						$selectEl.on('change', scope.refreshSelectric);

						$selectEl.selectric({
							customClass: {
								prefix: (selectEl.selOptions && selectEl.selOptions.elClass ? selectEl.selOptions.elClass + ' ' : '' ) + 'selectric'
							},
							responsive: true,
							disableOnMobile: false,
							arrowButtonMarkup: '<span class="selectric__arrow icon--angle-down"></span>',
							onBeforeOpen: function() {
								$(window).on('scroll.closeSelectric', scope.closeOnScroll.bind(this));
							},
							onBeforeClose: function() {
								$(window).off('.closeSelectric');
							},
							//Selectric is stupid.
							onChange: function() {
								$selectEl.trigger('change');
								$selectEl.trigger('blur');
							},
							optionsItemBuilder: scope.renderItem.bind(selectEl),
							labelBuilder: scope.renderItem.bind(selectEl)
						});
					}
				
				});
			}
		},

		renderItem: function(itemData) {
			let output = itemData.text;

			if(this.selOptions) {
				let customClass = this.selOptions.itemClass ? this.selOptions.itemClass : 'select--decoration',
					mappedAttr = this.selOptions.optionAttrMap ? this.selOptions.optionAttrMap : '';

				output = ('<span class="'+ customClass + ' ' + itemData.element[0].getAttribute(mappedAttr).toLowerCase() + '"></span>') + output;
			}

			return output;
		},

		//Mainly used to refresh selectric displayed element when autocomplete is fired/original element is changed without being trigger.
		refreshSelectric: function() {
			$(this).selectric('refresh');
		},

		//Closes the selectric dropdown if user scrolls
		closeOnScroll: function() {
			$(this).selectric('close');
		}
	},

	/**
	 * Scrolls window to first error field coming from BE.
	 */
	formrowError: {
		default: '.form-row.error',
		init: function(query) {
			window.scrollTo(0, $(query || this.default).offset().top - 20);
		}
	},

	/**
	 * Validation for international phone input fields.
	 */
	telInputs: {
		default: 'input.phone',
		init: function(query) { let telInputs = new TelInput(query || this.default); }
	},

	//Opens target URL on a new popup window (if it can).
	openWindow: {
		default: '[data-openwindow]',
		init: function(query) {
			var links = document.querySelectorAll(query || this.default);

			[].forEach.call(links, this.setHandler);
		},

		setHandler: function(link) {
			if(link.href) {
				link.addEventListener('click', function(evt){
					evt.preventDefault();
					window.open(this.href, '_blank', "menubar=yes,location=0,width=768,height=600,resizable=yes,scrollbars=yes,status=yes");
				});
			}
		}
	},
	showMoreSwatches: {
        init: function (query) {
			var showMoreQuery = query !== undefined?query:'.swatch-variation-wrap';
			var showMoreLinkEl = $(showMoreQuery).find('.show-more-link');
		    var swatchItem = $(showMoreQuery).find('.swatch-variation');
		    var selectedSwatchItem = $(showMoreQuery).find('.swatches__item.selected');
            var swatchesItems = $(showMoreQuery).find('.swatches__item');
            var contentWidth = swatchesItems.width() + parseFloat(swatchesItems.css('margin-right'));
            var containerWidth=swatchItem.width();
            var noOfItemsVisible = parseInt(containerWidth / contentWidth) * 2;
            var masterId = $('#pdpMain').data('pid');
            this.toggleShowMoreLink(showMoreLinkEl,noOfItemsVisible, swatchesItems.length);
            $(window).on('resize', () => {
                containerWidth = swatchItem.width();
                noOfItemsVisible = parseInt(containerWidth / contentWidth) * 2;
                this.toggleShowMoreLink(showMoreLinkEl,noOfItemsVisible, swatchesItems.length);
            });
            $(window).on('unload', () => {
                sessionStorage.removeItem('show-more-expand');
            });
            if (selectedSwatchItem.length > 0) {
                var sessionData;
                try {
                    sessionData = JSON.parse(sessionStorage['show-more-expand']);
                } catch (err) {
                    sessionData = null;
                }
                if (sessionData && sessionData.pid == masterId && sessionData.open) {
                    this.toggleSwatches.call(showMoreLinkEl);
                } else {
                    sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: false });
                }
		    }
			if(showMoreLinkEl.length > 0){
				showMoreLinkEl.off('click').on('click', this.toggleSwatches.bind(showMoreLinkEl));
            }
		},
		toggleSwatches: function(el) {
			var showMoreLinkEl = $(this);
            var swatchItem = showMoreLinkEl.closest('.swatch-variation-wrap').find('.swatch-variation');
            var masterId = $('#pdpMain').data('pid');
			if(swatchItem.length > 0) {
				if(swatchItem.hasClass('color-height')){
		        	swatchItem.removeClass('color-height');
                    showMoreLinkEl.html(Resources.QUICK_VIEW_LESS_VIEW).addClass('toggle--active');
                    sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: true });
		        }else{
		        	swatchItem.addClass('color-height');
		        	showMoreLinkEl.html(Resources.QUICK_VIEW_MORE_VIEW).removeClass('toggle--active');
                    sessionStorage['show-more-expand'] = JSON.stringify({ pid: masterId, open: false });
		        }
			}
        },
        toggleShowMoreLink: function (showMoreLinkEl,noOfItemsVisible,totalSwatches) {
            if (noOfItemsVisible >= totalSwatches) {
                showMoreLinkEl.addClass('hidden');
            } else {
                showMoreLinkEl.removeClass('hidden');
            }
        }
	},
	productRating: {
		default: '[data-rating]',
		init: function(query) { let productRating = new ProductRating(query || this.default); return productRating; }
	},
};

export default Modules;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/helpers/born.modules.js